import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { signIn } from 'src/authConfig';
import { GE_DOMAIN, NATIVE_REDIRECT, SFDC_DOMAIN } from 'src/Config/constants';

class NativeSupport extends Component {
	componentDidMount() {
		const loggedIn = window.sessionStorage.getItem('accessToken');
		const query = new URLSearchParams(this.props.location.search)
		const queryEmail = query.get('email');
		const queryLang = query.get('language') && query.get('language').length ? query.get('language') : 'en';
		if (loggedIn?.includes('Bearer')){
			console.log(jwt_decode(loggedIn).email);
			const jwtEmail = jwt_decode(loggedIn).email;
			console.log(queryEmail)
			if (jwtEmail?.toLowerCase() === queryEmail?.toLowerCase()){
				this.props.history.push('/authSupport')
			} else{
				window.localStorage.setItem(NATIVE_REDIRECT,'/authSupport')
				signIn(queryEmail.includes(GE_DOMAIN) ? GE_DOMAIN : SFDC_DOMAIN, true, queryEmail, queryLang)
			}
		} else{
			window.localStorage.setItem(NATIVE_REDIRECT, '/authsupport')
			signIn(queryEmail.includes(GE_DOMAIN) ? GE_DOMAIN : SFDC_DOMAIN, true, queryEmail, queryLang)
		}
	}
	render(){
		return<div className='app-container'></div>
	}
}

export default NativeSupport;